import { ADD_ABOUT, ADD_ACCOUNT, ADD_BATCH, ADD_DOCTOR, ADD_HSN, ADD_PATIENT, ADD_PRODUCT, ADMIN_DELETE, ADMIN_GET, ADMIN_UPDATE, ADMIN_USER, DELETE_ABOUT, DELETE_ACCOUNT, DELETE_BATCH, DELETE_DOCTOR, DELETE_HSN, DELETE_PATIENT, DELETE_PRODUCT, GET_ABOUT, GET_ACCOUNT, GET_BATCH, GET_DOCTOR, GET_HSN, GET_PATIENT, GET_PRODUCT, HSN_DROPDOWN, PARTY_DROPDOWN, PRODUCT_DROPDOWN, SEARCH_ACCOUNT, SEARCH_BATCH, SEARCH_DOCTOR, SEARCH_HSN, SEARCH_PATIENT, SEARCH_PRODUCT, UPDATE_ABOUT, UPDATE_ACCOUNT, UPDATE_BATCH, UPDATE_DOCTOR, UPDATE_HSN, UPDATE_PATIENT, UPDATE_PRODUCT } from "../actions/Master.action";

const initialState = {
    addAccount: '',
    updateAccount: '',
    getAccount: '',
    deleteAccount: '',
    addHsn: '',
    updateHsn: '',
    getHsn: '',
    deleteHsn: '',
    addProduct: '',
    updateProduct: '',
    getProduct: '',
    deleteProduct: '',
    addDoctor: '',
    updateDoctor: '',
    getDoctor: '',
    deleteDoctor: '',
    addPatient: '',
    updatePatient: '',
    getPatient: '',
    deletePatient: '',
    addBatch: '',
    updateBatch: '',
    getBatch: '',
    deleteBatch: '',
    addAbout: '',
    updateAbout: '',
    getAbout: '',
    deleteAbout: '',

    adminUser: '',
    adminGet: '',
    adminUpdate: '',
    adminDelete: '',
    hsnDropdown: '',
    productDropdown: '',
    partyDropdown: ''
}

const masterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ACCOUNT:
            return { ...state, addAccount: action.payload };
        case UPDATE_ACCOUNT:
            return { ...state, updateAccount: action.payload };
        case GET_ACCOUNT:
            return { ...state, getAccount: action.payload };
        case DELETE_ACCOUNT:
            return { ...state, deleteAccount: action.payload };
        case SEARCH_ACCOUNT:
            return { ...state, getAccount: action.payload };
        case ADD_HSN:
            return { ...state, addHsn: action.payload };
        case UPDATE_HSN:
            return { ...state, updateHsn: action.payload };
        case GET_HSN:
            return { ...state, getHsn: action.payload };
        case DELETE_HSN:
            return { ...state, deleteHsn: action.payload };
        case SEARCH_HSN:
            return { ...state, getHsn: action.payload };
        case ADD_PRODUCT:
            return { ...state, addProduct: action.payload };
        case UPDATE_PRODUCT:
            return { ...state, updateProduct: action.payload };
        case GET_PRODUCT:
            return { ...state, getProduct: action.payload };
        case DELETE_PRODUCT:
            return { ...state, deleteProduct: action.payload };
        case SEARCH_PRODUCT:
            return { ...state, getProduct: action.payload };
        case ADD_DOCTOR:
            return { ...state, addDoctor: action.payload };
        case UPDATE_DOCTOR:
            return { ...state, updateDoctor: action.payload };
        case GET_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case DELETE_DOCTOR:
            return { ...state, deleteDoctor: action.payload };
        case SEARCH_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case ADD_PATIENT:
            return { ...state, addPatient: action.payload };
        case UPDATE_PATIENT:
            return { ...state, updatePatient: action.payload };
        case GET_PATIENT:
            return { ...state, getPatient: action.payload };
        case DELETE_PATIENT:
            return { ...state, deletePatient: action.payload };
        case SEARCH_PATIENT:
            return { ...state, getPatient: action.payload };
        case ADD_BATCH:
            return { ...state, addBatch: action.payload };
        case UPDATE_BATCH:
            return { ...state, updateBatch: action.payload };
        case GET_BATCH:
            return { ...state, getBatch: action.payload };
        case DELETE_BATCH:
            return { ...state, deleteBatch: action.payload };
        case SEARCH_BATCH:
            return { ...state, getBatch: action.payload };
        case ADD_ABOUT:
            return { ...state, addAbout: action.payload };
        case UPDATE_ABOUT:
            return { ...state, updateAbout: action.payload };
        case GET_ABOUT:
            return { ...state, getAbout: action.payload };
        case DELETE_ABOUT:
            return { ...state, deleteAbout: action.payload };

        case ADMIN_USER:
            return { ...state, adminUser: action.payload };
        case ADMIN_GET:
            return { ...state, adminGet: action.payload };
        case ADMIN_UPDATE:
            return { ...state, adminUpdate: action.payload };
        case ADMIN_DELETE:
            return { ...state, adminDelete: action.payload };
        case HSN_DROPDOWN:
            return { ...state, hsnDropdown: action.payload };
        case PRODUCT_DROPDOWN:
            return { ...state, productDropdown: action.payload };
        case PARTY_DROPDOWN:
            return { ...state, partyDropdown: action.payload };
        default:
            return state;
    }
}

export default masterReducer;